module.exports = __webpack_public_path__ + "static/media/htr2.6e364751.jpg";